// Óleos da Etapa 3 da aba "Protocolos de Óleos Essenciais".
// Texto transcrito do arquivo protocolos_oleos_completo.md, sem reescrita.
// Só na aba. Não inclui os já cadastrados (Lemon Eucalyptus, Lime,
// Motivate e Zendocrine).

import type { FichaSituacoes } from './fichasSituacoes'

const INTERNO_AGUA =
  'pingue 1 gota em uma colher e tome com água. Se preferir, use uma cápsula vegetal.'

const ROLLON = 'Roll-on, já diluído: não precisa de proporção.'

export interface OleoEtapa3 {
  id: string
  portugues: string
  ingles: string
}

export const CATALOGO_ETAPA3: OleoEtapa3[] = [
  { id: 'novo-spearmint', portugues: 'Hortelã-Verde', ingles: 'Spearmint' },
  { id: 'novo-sunnycitrus', portugues: 'Sunny Citrus', ingles: 'Sunny Citrus' },
  { id: 'novo-tulsi', portugues: 'Manjericão-Santo', ingles: 'Tulsi' },
  { id: 'novo-wintergreen', portugues: 'Gaultéria', ingles: 'Wintergreen' },
  { id: 'novo-yarrowpom', portugues: 'Mix de Mil-folhas e Romã', ingles: 'Yarrow | Pom' },
  { id: 'novo-bergamotmint', portugues: 'Hortelã-Bergamota', ingles: 'Bergamot Mint' },
  { id: 'novo-breubranco', portugues: 'Breu Branco', ingles: 'Breu Branco' },
  { id: 'novo-cananga', portugues: 'Cananga', ingles: 'Cananga' },
  { id: 'novo-cassia', portugues: 'Canela-Cássia', ingles: 'Cassia' },
  { id: 'novo-celeryseed', portugues: 'Semente de Aipo', ingles: 'Celery Seed' },
  { id: 'novo-turmeric', portugues: 'Cúrcuma', ingles: 'Turmeric' },
  { id: 'novo-oregano', portugues: 'Orégano', ingles: 'Oregano' },
  { id: 'novo-ginger', portugues: 'Gengibre', ingles: 'Ginger' },
  { id: 'novo-grapefruit', portugues: 'Toranja', ingles: 'Grapefruit' },
  { id: 'novo-ravintsara', portugues: 'Canela-cânfora', ingles: 'Ravintsara' },
  { id: 'novo-rose', portugues: 'Rosa', ingles: 'Rose Touch' },
  { id: 'novo-salubelle', portugues: 'Salubelle', ingles: 'Salubelle' },
  { id: 'novo-spikenard', portugues: 'Nardo', ingles: 'Spikenard' },
  { id: 'novo-thyme', portugues: 'Tomilho', ingles: 'Thyme' },
  { id: 'novo-yuzu', portugues: 'Yuzu', ingles: 'Yuzu' },
  { id: 'novo-melissa', portugues: 'Melissa', ingles: 'Melissa' },
  { id: 'novo-nootka', portugues: 'Nootka', ingles: 'Nootka' },
  { id: 'novo-patchouli', portugues: 'Patchouli', ingles: 'Patchouli' },
  { id: 'novo-peace', portugues: 'Peace', ingles: 'Peace' },
  { id: 'novo-motivatetouch', portugues: 'Motivate Touch', ingles: 'Motivate Touch' },
  { id: 'novo-cheertouch', portugues: 'Cheer Touch', ingles: 'Cheer Touch' },
  { id: 'novo-passiontouch', portugues: 'Passion Touch', ingles: 'Passion Touch' },
  { id: 'novo-forgivetouch', portugues: 'Forgive Touch', ingles: 'Forgive Touch' },
  { id: 'novo-consoletouch', portugues: 'Console Touch', ingles: 'Console Touch' },
  { id: 'novo-peacetouch', portugues: 'Peace Touch', ingles: 'Peace Touch' },
  { id: 'novo-stronger', portugues: 'Stronger', ingles: 'Stronger' },
  { id: 'novo-thinker', portugues: 'Thinker', ingles: 'Thinker' },
  { id: 'novo-eucalyptus', portugues: 'Eucalipto', ingles: 'Eucalyptus' },
  { id: 'novo-wildorange', portugues: 'Laranja-Selvagem', ingles: 'Wild Orange' },
  { id: 'novo-deepbluetouch', portugues: 'Mix Calmante', ingles: 'Deep Blue Touch' },
  { id: 'novo-oreganotouch', portugues: 'Orégano', ingles: 'Oregano Touch' },
  { id: 'novo-frankincensetouch', portugues: 'Olíbano', ingles: 'Frankincense Touch' },
  { id: 'novo-helichrysumtouch', portugues: 'Helicriso', ingles: 'Helichrysum Touch' },
  { id: 'novo-melaleucatouch', portugues: 'Melaleuca', ingles: 'Melaleuca Touch' },
]

export const FICHAS_ETAPA3: Record<string, FichaSituacoes> = {
  'novo-stronger': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Aflição emocional e limites fracos',
        aromatico: 'nas mãos em concha.',
        topico: 'sola dos pés.',
      },
      {
        situacao: 'Apoio à imunidade',
        topico: 'sob o nariz, coração, coluna e/ou sola dos pés.',
      },
    ],
  },

  'novo-thinker': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Foco, sobrecarga, estresse, nervosismo, tristeza de fim de tarde',
        nota: 'sob o nariz, testa, coluna, nuca e/ou sola dos pés.',
      },
    ],
  },

  'novo-spearmint': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      { situacao: 'Foco', topico: 'na nuca e sob o nariz.' },
      { situacao: 'Depressão e fadiga', aromatico: 'difusor.', topico: 'na nuca.' },
      { situacao: 'Estresse e nervosismo', aromatico: 'difusor.', topico: 'na nuca.' },
      {
        situacao: 'Dor de cabeça',
        aromatico: 'difusor.',
        topico: 'nas têmporas e na nuca.',
      },
      { situacao: 'Indigestão, náusea e cólica', topico: 'sobre o abdômen.' },
      {
        situacao: 'Menstruação lenta ou intensa',
        aromatico: 'difusor.',
        topico: 'no abdômen ou na nuca.',
      },
      { situacao: 'Refrigeração', topico: 'atrás do pescoço.' },
    ],
    atencao: 'pele sensível, sempre diluir.',
  },

  'novo-sunnycitrus': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      { situacao: 'Ânimo e disposição', aromatico: 'difusor ou inale 1 gota nas mãos em concha.' },
      { situacao: 'Foco e concentração', aromatico: 'difusor ou inale 1 gota nas mãos em concha.' },
      {
        situacao: 'Estresse e fadiga mental',
        aromatico: 'difusor, ou 1 gota na palma das mãos, espalhe e inale por alguns minutos.',
      },
      {
        situacao: 'Ansiedade e tristeza',
        aromatico: 'difusor ou nas mãos em concha.',
        topico: 'algumas gotas em um roll-on de 10 ml completado com óleo de coco, nos pulsos e na sola dos pés.',
      },
      {
        situacao: 'Respiração',
        aromatico: 'difusor, ou 2 gotas em uma caneca de água quente e inspire o vapor.',
      },
      {
        situacao: 'Suporte digestivo',
        topico: 'massageando o abdômen.',
      },
    ],
  },

  'novo-tulsi': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Calmante e relaxante',
        aromatico: '1 gota na palma das mãos e inspire, ou difusor com lavanda.',
        topico: 'na nuca ou na sola dos pés.',
      },
      { situacao: 'Meditação', aromatico: 'difusor.' },
      { situacao: 'Imunidade', topico: 'na sola dos pés.' },
      { situacao: 'Reparo da pele', nota: 'adicione 1 gota ao hidratante.' },
      {
        situacao: 'Alergias sazonais',
        aromatico: 'combine com Limão e Laranja Selvagem e inale.',
      },
    ],
    atencao: 'pele sensível, sempre diluir.',
  },

  'novo-wintergreen': {
    diluicao: '1 gota + 20 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Dores musculares e articulares, cãibras, contusões',
        topico: 'na área afetada.',
      },
      { situacao: 'Aquecimento e circulação das extremidades', topico: 'nas áreas afetadas.' },
      { situacao: 'Dermatite e irritação', topico: 'nas áreas afetadas.' },
    ],
    atencao:
      'NUNCA ingerir. Pode aquecer a pele e ser irritante para a pele sensível. Usar sempre na proporção de 1 gota para 20 de óleo de coco fracionado.',
  },

  'novo-yarrowpom': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Envelhecimento e flacidez da pele',
        topico: 'aplique com óleo transportador na área, com compressa quente para aprofundar.',
      },
      {
        situacao: 'Má circulação e baixa transpiração',
        topico: 'nas solas dos pés ou na área de interesse. Banho de vapor para promover transpiração.',
      },
      { situacao: 'Dor e inflamação', topico: 'na área de interesse.' },
    ],
  },

  'novo-bergamotmint': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Concentração',
        aromatico: 'difusor.',
        topico: 'sob o nariz, testa, nuca e dedos dos pés.',
      },
      {
        situacao: 'Calmante e meditação',
        aromatico: 'difusor.',
        topico: 'nos pontos de pulsação, nuca, coluna e sola dos pés.',
      },
      {
        situacao: 'Falta de energia, motivação e pessimismo',
        aromatico: 'difusor.',
        topico: 'sob o nariz, coração e testa.',
      },
      {
        situacao: 'Agitação e dificuldade para dormir',
        aromatico: 'difusor.',
        topico: 'sob o nariz e na sola dos pés.',
      },
      {
        situacao: 'Inchaço, gases e náusea',
        topico: 'no abdômen, sola dos pés e sob o nariz.',
      },
      {
        situacao: 'Desconforto menstrual',
        aromatico: 'difusor.',
        topico: 'sob o nariz e no baixo abdômen.',
      },
      { situacao: 'Dores musculares', topico: 'nas regiões afetadas.' },
    ],
  },

  'novo-breubranco': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Calmante e relaxante',
        aromatico: '1 gota na palma das mãos e inspire.',
        topico: 'na nuca ou na sola dos pés.',
      },
      {
        situacao: 'Insônia, estresse e tensão',
        aromatico: 'difusor.',
        topico: 'nas solas dos pés.',
      },
      { situacao: 'Fortalecimento imunológico', topico: 'na sola dos pés.' },
      {
        situacao: 'Congestão e resfriado',
        aromatico: 'algumas gotas em tigela de água quente, cubra a cabeça com toalha e respire fundo.',
      },
      { situacao: 'Dores musculares e tensão', topico: 'massageando o local.' },
      { situacao: 'Cortes e feridas', topico: 'na área.' },
    ],
    atencao: 'pele sensível, sempre diluir.',
  },

  'novo-cananga': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Ansiedade e tristeza',
        aromatico: 'difusor, ou 1 gota na palma das mãos, espalhe e inale por alguns minutos.',
        topico: 'nos pulsos e na coluna.',
      },
      { situacao: 'Manchas escuras', topico: 'no local, 2 a 3 vezes ao dia.' },
    ],
  },

  'novo-cassia': {
    diluicao: '1 gota + 20 de óleo de coco fracionado',
    situacoes: [
      { situacao: 'Extremidades frias', topico: 'na sola dos pés.' },
      { situacao: 'Digestão e gastrite nervosa', interno: 'SOMENTE em cápsula.' },
      {
        situacao: 'Apoio imunológico',
        interno: 'SOMENTE em cápsula.',
        aromatico: 'difusor.',
        nota: 'Nunca inalar puro nas mãos.',
      },
      { situacao: 'Metabolismo', interno: 'SOMENTE em cápsula.' },
    ],
    atencao:
      'Recomenda-se INGERIR EM CÁPSULA, pois pode causar irritação e ardência ao ingerir puro com água. Diluir sempre 1 gota para 20 de óleo de coco fracionado no uso tópico. A pele pode ficar temporariamente aquecida e vermelha. Tenha cautela no uso e siga as orientações.',
  },

  'novo-celeryseed': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Retenção de líquidos',
        interno: '1 a 2 gotas dissolvidas em água ou suco, conforme necessário.',
        topico: 'na parte inferior do abdômen e planta dos pés.',
      },
      {
        situacao: 'Desintoxicação (sangue e fígado)',
        interno: '1 a 2 gotas em cápsula.',
        topico: 'na planta dos pés e sobre o fígado, 2 a 4 vezes ao dia.',
      },
      {
        situacao: 'Articulações rígidas',
        topico: 'na planta dos pés e áreas de interesse, 2 a 4 vezes ao dia.',
      },
      {
        situacao: 'Indigestão e gases',
        interno: '1 a 2 gotas em cápsula.',
        topico: 'no abdômen.',
      },
    ],
    atencao: 'pele sensível, sempre diluir.',
  },

  'novo-turmeric': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Dores e inflamações',
        interno: 'depois da refeição, uso diário.',
        topico: 'na área.',
      },
      { situacao: 'Infecções e viroses (apoio imunológico)', interno: 'depois da refeição.' },
      {
        situacao: 'Ansiedade e estresse',
        aromatico: 'inale 1 gota nas mãos em concha ou no difusor.',
        topico: 'parte de trás da cabeça e ao longo da coluna.',
      },
      {
        situacao: 'Desânimo e tensão',
        aromatico: 'inale 1 gota nas mãos em concha ou no difusor.',
      },
    ],
  },

  'novo-oregano': {
    diluicao: '1 gota + 20 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Apoio à imunidade',
        interno: 'SOMENTE em cápsula.',
        topico: 'sola dos pés ou costas.',
      },
    ],
    atencao:
      'INGERIR SOMENTE EM CÁPSULA. NUNCA ingerir puro com água. NUNCA colocar nas mãos para inalar. Inalação apenas no difusor.',
  },

  'novo-ginger': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Desconfortos digestivos (enjoo, náusea, azia, cólicas)',
        interno: 'com água morna.',
        topico: 'abdômen.',
      },
      { situacao: 'Inflamações', interno: INTERNO_AGUA },
      { situacao: 'Dores musculares', topico: 'massagear na área.' },
      {
        situacao: 'Energia e foco',
        aromatico: 'inale 1 gota nas mãos em concha ou no difusor.',
      },
      { situacao: 'Memória', aromatico: 'inale 1 gota nas mãos em concha.' },
    ],
    atencao: 'NÃO usar em caso de pressão alta.',
  },

  'novo-grapefruit': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Saciedade',
        interno: 'algumas gotas em um copo de água, ou em cápsula.',
      },
      {
        situacao: 'Drenagem e desintoxicação',
        interno: 'algumas gotas em água.',
        topico: 'sola dos pés. Celulite: na área.',
      },
      {
        situacao: 'Equilíbrio emocional',
        aromatico: 'inale 1 gota nas mãos em concha ou no difusor.',
      },
    ],
    atencao: 'não aplicar na pele antes de exposição ao sol (causa manchas).',
  },

  'novo-ravintsara': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Resfriados e vias aéreas',
        aromatico: 'inale nas mãos em concha, ou 1 a 2 gotas em tigela de água quente (vapor).',
      },
      { situacao: 'Foco e concentração', aromatico: 'nas mãos em concha ou difusor.' },
      {
        situacao: 'Estresse e irritabilidade',
        aromatico: 'nas mãos em concha.',
        topico: 'pulsos e sola dos pés.',
      },
      {
        situacao: 'Pernas cansadas',
        topico: 'massagem nas pernas. Escalda-pés: 2 a 4 gotas com sais de banho.',
      },
    ],
  },

  'novo-rose': {
    comoAplicar:
      'Roll-on já diluído com óleo de coco fracionado. Pode ser utilizado diretamente na pele.',
    situacoes: [
      {
        situacao: 'Luto e tristeza',
        topico: 'atrás do pescoço e sobre o coração.',
      },
      { situacao: 'Pele', topico: 'na área de interesse.' },
    ],
  },

  'novo-salubelle': {
    comoAplicar: ROLLON,
    situacoes: [
      { situacao: 'Meditação', topico: 'sob o nariz ou nos pontos de pulsação.' },
      { situacao: 'Rugas e linhas finas', topico: 'rosto, pescoço e mãos.' },
      { situacao: 'Manchas, cicatrizes e estrias', topico: 'nas áreas afetadas.' },
    ],
  },

  'novo-spikenard': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      { situacao: 'Insônia, estresse e tensão', aromatico: 'difusor.', topico: 'sola dos pés.' },
      { situacao: 'TPM', topico: 'abdômen, nuca e pontos de pulsação.' },
      { situacao: 'Pele', nota: '1 gota no limpador facial ou hidratante.' },
    ],
  },

  'novo-thyme': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Memória, concentração e alerta',
        aromatico: 'nas mãos em concha.',
        topico: 'parte de trás do pescoço.',
      },
    ],
  },

  'novo-yuzu': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Ansiedade',
        aromatico: 'nas mãos em concha ou difusor.',
        topico: 'pulsos e sola dos pés.',
      },
      {
        situacao: 'Elevar o humor',
        aromatico: 'nas mãos em concha ou difusor, por alguns minutos.',
      },
      {
        situacao: 'Circulação e relaxamento',
        topico: 'em sabonete líquido neutro no corpo, ou escalda-pés.',
      },
    ],
  },

  'novo-melissa': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Depressão, ansiedade e choque',
        aromatico: 'difusor.',
        topico: 'nuca e orelhas.',
      },
    ],
    atencao: 'pele sensível, sempre diluir.',
  },

  'novo-nootka': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      { situacao: 'Estresse e humor', aromatico: 'nas mãos em concha ou difusor.' },
      { situacao: 'Relaxamento muscular', topico: '' },
      { situacao: 'Pele e acne', topico: '' },
    ],
  },

  'novo-patchouli': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Ansiedade',
        aromatico: 'difusor.',
        topico: 'sob o nariz e nuca.',
      },
      { situacao: 'Pele seca e caspa', topico: '' },
      { situacao: 'Nervos', topico: '' },
    ],
  },

  'novo-peace': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Insegurança, nervosismo e irritabilidade',
        aromatico: '',
        topico: 'sob o nariz e nuca.',
      },
      { situacao: 'Foco', aromatico: '', topico: 'testa ou nuca.' },
      { situacao: 'Meditação', aromatico: 'difusor.', topico: 'sob o nariz.' },
      {
        situacao: 'Estresse e hiperatividade',
        aromatico: '',
        topico: 'nariz, nuca e testa.',
      },
      { situacao: 'Cólica e calmante', topico: 'sola dos pés e abdômen.' },
    ],
  },

  // ─── Versões Touch (roll-on, já diluídas, sem proporção) ──────────────────

  'novo-motivatetouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Confiança, coragem ou motivação',
        aromatico: 'inale das mãos em concha.',
        topico: 'nariz, testa, nuca, peito, pulsos ou estômago.',
      },
      {
        situacao: 'Fadiga mental e exaustão',
        aromatico: 'inale das mãos em concha.',
        topico: 'têmporas, nuca e pulsos.',
      },
      {
        situacao: 'Depleção e estagnação',
        aromatico: 'inale das mãos em concha.',
        topico: 'pulsos, nuca ou peito.',
      },
      {
        situacao: 'Esgotamento físico',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz, suprarrenais, sola dos pés, pulsos ou nuca.',
      },
      {
        situacao: 'Confusão e sobrecarga',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz, testa, nuca ou peito.',
      },
      {
        situacao: 'Tristeza e desânimo',
        aromatico: 'inale das mãos em concha.',
        topico: 'peito, testa e nuca.',
      },
      { situacao: 'Problemas digestivos', topico: 'estômago/abdômen, pulsos ou sola dos pés.' },
      { situacao: 'Perfume', topico: 'pulsos, nuca ou peito.' },
    ],
    atencao:
      'contém cítricos. Não aplicar na pele antes de exposição ao sol, aguardar 12 horas.',
  },

  'novo-cheertouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Depressão e desânimo',
        aromatico: 'inale das mãos em concha.',
        topico: 'pulsos, sob o nariz, testa, nuca ou peito.',
      },
      {
        situacao: 'Ansiedade',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz, testa, pulsos ou nuca.',
      },
      {
        situacao: 'Desconexão',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz e testa.',
      },
      {
        situacao: 'TPM',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz, testa ou estômago/abdômen.',
      },
      { situacao: 'Inflamação e rigidez', topico: 'na área afetada.' },
      { situacao: 'Indigestão', topico: 'estômago/abdômen e sola dos pés.' },
      { situacao: 'Perfume', topico: 'pulsos, nuca ou peito.' },
    ],
  },

  'novo-passiontouch': {
    comoAplicar: ROLLON,
    situacoes: [
      { situacao: 'Apatia e baixa energia', aromatico: 'inale das mãos em concha.' },
      {
        situacao: 'Névoa mental e memória',
        aromatico: 'inale das mãos em concha.',
        topico: 'dedos, pulsos, nuca ou peito.',
      },
      { situacao: 'Digestão e eliminação lentas', topico: 'estômago/abdômen inferior.' },
      {
        situacao: 'Menstruação e menopausa',
        topico: 'abdômen inferior ou tornozelos (dentro e fora).',
      },
      { situacao: 'Perfume', topico: 'pulsos, nuca ou peito.' },
    ],
  },

  'novo-forgivetouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Perdão e apego',
        aromatico: 'inale das mãos em concha.',
        topico: 'têmporas e nuca.',
      },
      {
        situacao: 'Ansiedade',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz, testa e/ou nuca, para acalmar e aterrar.',
      },
      {
        situacao: 'Toxicidade emocional',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz e/ou peito.',
      },
      {
        situacao: 'Irritabilidade',
        aromatico: 'inale das mãos em concha.',
        topico: 'pontos de pulsação.',
      },
      { situacao: 'Perfume', topico: 'pulsos ou pescoço.' },
    ],
    atencao:
      'contém cítricos. Não aplicar na pele antes de exposição ao sol, aguardar 12 horas.',
  },

  'novo-consoletouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Luto e tristeza',
        aromatico: 'inale das mãos em concha.',
        topico: 'nariz e peito.',
      },
      {
        situacao: 'Liberação emocional e reafirmação',
        aromatico: 'inale das mãos em concha.',
        topico: 'nariz e coração.',
      },
      {
        situacao: 'Medo e alívio emocional da dor',
        aromatico: 'inale das mãos em concha.',
        topico: 'nariz e peito.',
      },
      { situacao: 'Pele', topico: 'na área de interesse.' },
      { situacao: 'Perfume', topico: 'pulsos ou pescoço.' },
    ],
    atencao:
      'contém cítricos. Não aplicar na pele antes de exposição ao sol, aguardar 12 horas.',
  },

  'novo-peacetouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Insegurança e preocupação',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz e nuca.',
      },
      {
        situacao: 'Nervosismo e irritabilidade',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz e nuca.',
      },
      { situacao: 'Foco', aromatico: 'inale das mãos em concha.', topico: 'testa ou nuca.' },
      {
        situacao: 'Meditação',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz.',
      },
      {
        situacao: 'Estresse, tensão mental e hiperatividade',
        aromatico: 'inale das mãos em concha.',
        topico: 'nariz, nuca e testa.',
      },
      { situacao: 'Cólica e calmante', topico: 'sola dos pés e abdômen.' },
      { situacao: 'Perfume', topico: 'pulsos ou pescoço.' },
    ],
  },

  'novo-eucalyptus': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Congestão e tosse',
        aromatico: 'difusor ou inale das mãos em concha.',
        topico: 'peito e sobre a ponte do nariz.',
      },
      {
        situacao: 'Resfriado e gripe',
        aromatico: 'difusor.',
        topico: 'sola dos pés ou ao longo da coluna.',
      },
      {
        situacao: 'Sinusite e respiração',
        aromatico: 'inale das mãos em concha.',
        topico: 'peito e pés.',
      },
      {
        situacao: 'Sensibilidade ao calor',
        topico: 'com hortelã-pimenta, na coluna, para efeito de resfriamento.',
      },
      {
        situacao: 'Fadiga muscular e dor',
        topico: 'músculos excessivamente usados.',
      },
      {
        situacao: 'Celulite',
        topico: 'massageie em áreas de preocupação.',
      },
    ],
    atencao: 'Nunca ingerir.',
  },

  'novo-wildorange': {
    diluicao: '1 gota + 10 de óleo de coco fracionado',
    situacoes: [
      {
        situacao: 'Insônia e estresse',
        aromatico: 'difusor ou inale das mãos em concha.',
        interno: `${INTERNO_AGUA} (na hora de dormir)`,
      },
      {
        situacao: 'Digestão (azia e intestino lento)',
        interno: 'em cápsula, com gengibre.',
      },
      {
        situacao: 'Concentração',
        aromatico: 'combine com hortelã e use no difusor ou inale das mãos em concha.',
      },
      {
        situacao: 'Resfriado',
        aromatico: '',
        topico: 'sola dos pés.',
      },
      {
        situacao: 'Desintoxicação e regeneração',
        interno: INTERNO_AGUA,
      },
      {
        situacao: 'Equilíbrio emocional',
        aromatico: '',
        topico: '',
      },
      {
        situacao: 'Falta de energia, criatividade e produtividade',
        aromatico: 'difusor.',
        topico: 'sob o nariz.',
        interno: 'em cápsula.',
      },
      {
        situacao: 'Medo, ansiedade e irritabilidade',
        aromatico: 'inale das mãos em concha.',
        topico: 'sob o nariz, testa ou pontos de pulsação.',
      },
    ],
    atencao: 'não aplicar na pele antes de exposição ao sol (causa manchas).',
  },

  'novo-deepbluetouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Dores musculares, tensão e articulações',
        topico: 'na área afetada.',
      },
      {
        situacao: 'Dor de cabeça e enxaqueca',
        topico: 'nas têmporas, nuca e ombros.',
      },
    ],
    atencao: 'nunca ingerir. Nunca aplicar em feridas abertas.',
  },

  'novo-oreganotouch': {
    comoAplicar: ROLLON,
    situacoes: [
      { situacao: 'Apoio à imunidade', topico: 'sola dos pés ou costas.' },
    ],
    atencao: 'NUNCA ingerir. Não colocar nas mãos para inalar.',
  },

  'novo-frankincensetouch': {
    comoAplicar: ROLLON,
    situacoes: [
      {
        situacao: 'Equilíbrio emocional',
        aromatico: 'inale das mãos em concha.',
        topico: 'nuca, área do peito e pulsos.',
      },
      { situacao: 'Pele e manchas', topico: 'na área afetada.' },
      { situacao: 'Cicatrizes e estrias', topico: 'na área afetada.' },
    ],
  },

  'novo-helichrysumtouch': {
    comoAplicar: ROLLON,
    situacoes: [
      { situacao: 'Rugas e estrias', topico: 'na área de interesse.' },
      { situacao: 'Cicatrizes e feridas', topico: 'na área.' },
      { situacao: 'Choque e dor', topico: 'nuca ou área.' },
    ],
  },

  'novo-melaleucatouch': {
    comoAplicar: ROLLON,
    situacoes: [
      { situacao: 'Pele sensível e acne', topico: 'na área afetada.' },
      { situacao: 'Imunidade', topico: 'sob a garganta, nariz, coluna e sola dos pés.' },
    ],
  },
}
